import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { TableContainer } from "@mui/material";

import { ChargeSupplyDayConstants } from "./ChargeSupplyDaysConstants";
import { ChargerSupplyDays } from "@/models/chargeSupplyDays";
import { formatKwh } from "@/util";

export type chargeSupplyDaysSumProps = {
  chargerSupplyDaysSum?: ChargerSupplyDays;
};

export const ChargeSupplyDaysSum = (props: chargeSupplyDaysSumProps) => {
  const { chargerSupplyDaysSum } = props;

  return (
    <React.Fragment>
      <TableContainer>
        <Table size="small">
          <TableHead className="list-head">
            <TableRow>
              <TableCell width="40%">
                {ChargeSupplyDayConstants.OfficeName}
              </TableCell>
              <TableCell width="20%">
                {ChargeSupplyDayConstants.TargetDate}
              </TableCell>
              <TableCell width="30%" align="right">
                {ChargeSupplyDayConstants.ChargeElectricPowerSum}
              </TableCell>
              <TableCell width="10%" />
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow sx={{ wordBreak: "break-all" }}>
              <TableCell>{chargerSupplyDaysSum?.displayName}</TableCell>
              <TableCell>
                {chargerSupplyDaysSum?.targetAt?.replaceAll("-", "/")}
              </TableCell>
              <TableCell sx={{ textAlign: "right" }}>
                {formatKwh(chargerSupplyDaysSum?.chargeKwh ?? NaN)}
              </TableCell>
              <TableCell />
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </React.Fragment>
  );
};
